document.addEventListener('DOMContentLoaded', () => {
  const quizContainers = document.querySelectorAll('.custom-quiz-container');

  quizContainers.forEach(container => {
    let currentStepIndex = 0;
    const collectedAnswers = []; // Stores the actual button text
    
    const mainHeader = container.querySelector('.custom-quiz-main-header');
    const steps = container.querySelectorAll('.custom-quiz-step:not(.custom-quiz-email-step)');
    const emailStep = container.querySelector('.custom-quiz-email-step');
    const resultsSection = container.querySelector('.custom-quiz-results');
    const resultsGrid = container.querySelector('.custom-quiz-results-grid');
    const progressBar = container.querySelector('.custom-quiz-progress-fill');
    const progressText = container.querySelector('.custom-quiz-progress-text-current');
    const progressTotal = container.querySelector('.custom-quiz-progress-text-total');
    
    const productPayloadData = container.querySelector('.custom-quiz-product-data');
    const masterProducts = JSON.parse(productPayloadData ? productPayloadData.textContent : '[]');
    const totalSteps = steps.length + (emailStep ? 1 : 0);

    if (progressTotal) progressTotal.innerText = totalSteps;

    function updateProgress() {
      if (!progressBar) return;
      const progressPercentage = (currentStepIndex / totalSteps) * 100;
      progressBar.style.width = `${progressPercentage}%`;
      if (progressText) progressText.innerText = Math.min(currentStepIndex + 1, totalSteps);
    }

    function showStep(index) {
      steps.forEach((step, i) => step.classList.toggle('is-active', i === index));
      if (emailStep) emailStep.classList.toggle('is-active', index === steps.length);
      resultsSection.classList.remove('is-active');
      if (mainHeader) mainHeader.style.display = 'block';
      updateProgress();
    }

    function showResults() {
      steps.forEach(step => step.classList.remove('is-active'));
      if (emailStep) emailStep.classList.remove('is-active');
      if (mainHeader) mainHeader.style.display = 'none'; 
      
      calculateRecommendations();
      
      if (progressBar) progressBar.style.width = `100%`;
      const pText = container.querySelector('.custom-quiz-progress-text');
      if (pText) pText.innerText = "Quiz Complete";
      
      resultsSection.classList.add('is-active');
    }

    function calculateRecommendations() {
      const validAnswers = collectedAnswers.filter(a => a && a.trim() !== '');

      if (validAnswers.length === 0 && masterProducts.length > 0) {
         renderResults(masterProducts.slice(0, 4));
         return;
      }

      // Stop words to ignore in partial matching
      const stopWords = ['and', 'the', 'with', 'for', 'yes', 'not', 'sure', 'keep', 'need', 'advice', 'have', 'dye', 'plans'];

      const scoredProducts = masterProducts.map(product => {
        let score = 0;
        const lowerTitle = product.title.toLowerCase();
        const productTags = product.tags ? product.tags.map(tag => tag.toLowerCase()) : [];
        
        validAnswers.forEach(answer => {
          const lowerAnswer = answer.toLowerCase().trim();
          
          // 1. FULL MATCH CHECK (Weighted heavily: +5 points)
          // Checks if the exact button text is in the title or tags
          if (lowerTitle.includes(lowerAnswer) || productTags.some(tag => tag.includes(lowerAnswer) || lowerAnswer.includes(tag))) {
            score += 5;
          }

          // 2. PARTIAL MATCH CHECK (Standard weight: +1 point)
          // Breaks the answer down into significant words
          const words = lowerAnswer.split(/[\s,()/-]+/).filter(w => w.length > 2 && !stopWords.includes(w));
          
          words.forEach(word => {
            if (lowerTitle.includes(word) || productTags.some(tag => tag.includes(word))) {
               score += 1;
            }
          });
        });
        
        return { ...product, score };
      });

      scoredProducts.sort((a, b) => b.score - a.score);
      let finalRecommendations = scoredProducts.filter(p => p.score > 0);
      
      if (finalRecommendations.length === 0) finalRecommendations = masterProducts;

      renderResults(finalRecommendations.slice(0, 4));
    }

    function renderResults(products) {
      resultsGrid.innerHTML = '';
      products.forEach(product => {
        const cardHtml = `
          <a href="${product.url}" class="custom-quiz-product-card">
            <img src="${product.image}" alt="${product.title}" class="custom-quiz-product-image" loading="lazy">
            <h3 class="custom-quiz-product-title">${product.title}</h3>
            <div class="custom-quiz-product-price">${product.price}</div>
          </a>
        `;
        resultsGrid.insertAdjacentHTML('beforeend', cardHtml);
      });
    }

    // Handle Answers
    const answerButtons = container.querySelectorAll('.custom-quiz-answers .custom-quiz-btn');
    answerButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        // Grab the actual text from the button
        const answerText = e.target.innerText || e.target.textContent;
        collectedAnswers[currentStepIndex] = answerText.trim();
        currentStepIndex++;

        if (currentStepIndex < steps.length) {
          showStep(currentStepIndex);
        } else if (emailStep) {
          showStep(steps.length);
        } else {
          showResults();
        }
      });
    });

    // Handle Back Buttons
    const backButtons = container.querySelectorAll('.custom-quiz-back-btn');
    backButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (currentStepIndex > 0) {
          currentStepIndex--;
          collectedAnswers.pop(); 
          showStep(currentStepIndex);
        }
      });
    });

    // Handle Email Form Submission 
    const emailForm = container.querySelector('#QuizEmailForm');
    if (emailForm) {
      const submitBtn = emailForm.querySelector('.custom-quiz-submit-btn');
      submitBtn.addEventListener('click', (e) => {
        if (!emailForm.checkValidity()) return; 

        e.preventDefault();
        submitBtn.innerText = 'Sending...';

        const formData = new FormData(emailForm);
        
        fetch(emailForm.action, {
          method: 'POST',
          body: formData,
          headers: { 
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          }
        })
        .then(() => { showResults(); })
        .catch(() => { showResults(); });
      });
    }

    // Restart logic
    const restartBtn = container.querySelector('.custom-quiz-restart');
    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        collectedAnswers.length = 0;
        currentStepIndex = 0;
        const pText = container.querySelector('.custom-quiz-progress-text');
        if (pText) pText.innerHTML = `STEP <span class="custom-quiz-progress-text-current">1</span> OF <span class="custom-quiz-progress-text-total">${totalSteps}</span>`;
        if (emailForm) {
            const submitBtn = emailForm.querySelector('.custom-quiz-submit-btn');
            if(submitBtn) submitBtn.innerText = 'Continue';
            emailForm.reset();
        }
        showStep(0);
      });
    }

    // INITIALIZATION
    const isPostReload = window.location.search.includes('customer_posted=true');
    
    if (isPostReload) {
      window.history.replaceState(null, null, window.location.pathname);
      showResults();
    } else if (steps.length > 0) {
      showStep(0);
    }
  });
});